import { Blocks, Bot, Database, Sparkles, Tv, Music, Film, Shield, Key, Monitor, Gamepad2, Send, Cpu, Layers } from "lucide-react";

const icons: Record<string, any> = {
  chatAi: Bot,
  geminiAi: Sparkles,
  builderAi: Blocks,
  databaseAi: Database,
  gemini: Sparkles,
  chatgpt: Bot,
  netflix: Tv,
  spotify: Music,
  youtube: Film,
  apple: Music,
  telegram: Send,
  nordvpn: Shield,
  windows: Monitor,
  office: Key,
  prime: Sparkles,
  bot: Bot,
  software: Monitor,
  gaming: Gamepad2,
  default: Sparkles,
};

export type AnimationKey = keyof typeof icons | string;

export function ProductAnimation({
  animation,
  label,
  fallback,
  large = false,
}: {
  animation?: AnimationKey | undefined;
  label: string;
  fallback?: string;
  large?: boolean;
}) {
  const Icon = (animation && icons[animation]) ? icons[animation] : null;

  if (!Icon) {
    const textFallback = fallback || (label && label.length >= 2 ? label.substring(0, 2).toUpperCase() : "DP");
    return (
      <span
        className={`grid place-items-center rounded-xl border bg-card font-black text-foreground shadow-card ${
          large ? "size-32 text-4xl sm:size-40 sm:text-5xl" : "size-14 text-lg sm:size-20 sm:text-2xl"
        }`}
      >
        {textFallback}
      </span>
    );
  }

  return (
    <div
      role="img"
      aria-label={`${label} animated illustration`}
      className={`relative grid place-items-center ${large ? "size-40 sm:size-52" : "size-20 sm:size-24"}`}
    >
      <span aria-hidden="true" className="absolute inset-0 rounded-full border-2 border-dashed border-primary/40 animate-[spin_16s_linear_infinite]" />
      <span aria-hidden="true" className="absolute inset-[13%] rounded-full border border-primary/30 animate-[spin_9s_linear_infinite_reverse]" />
      <span aria-hidden="true" className="absolute inset-[22%] rounded-full bg-background/80 shadow-card" />
      <span aria-hidden="true" className="absolute inset-0 animate-[spin_7s_linear_infinite]">
        <span className="absolute left-1/2 top-0 size-2 -translate-x-1/2 rounded-full bg-primary" />
      </span>
      <span aria-hidden="true" className="absolute inset-[22%] rounded-full bg-primary/10 animate-ping" />
      <Icon className={`relative text-primary ${large ? "size-14 sm:size-20" : "size-7 sm:size-9"}`} />
    </div>
  );
}
